import { getCollectionByHandle, Collection } from './collections';
import { loadImageIntoElement } from './image';

// A class that represents a pair of: 1) a placeholder collection  and 2) a actual collection
class CollectionPair {
    placeholder: HTMLElement;
    collection: HTMLElement;

    constructor(placeholder: HTMLElement, collection: HTMLElement) {
        this.placeholder = placeholder;
        this.collection = collection;
    }
}

export class CollectionsPage {
    constructor() {
        
    }

    public getCollectionsByHandles(collectionHandles: Array<string>) : Promise<Collection>[] {
        return collectionHandles.map((handle) => getCollectionByHandle(handle));
    }

    public setupPage(collectionsPromises: Promise<Collection>[]) {
        
        if(document.readyState === "loading") {
            throw new Error("Cannot setup collections page when document is still loading");
        }

        // Get the placeholder template with id the placeholder-collection-template
        const collectionPlaceholderTemplate = document.getElementById('placeholder-collection-template') as HTMLTemplateElement;
        if(collectionPlaceholderTemplate === null) {
            throw new Error("No template element with id 'collection-template' was found");
        }

        // Get the placeholder template with id the collection-template
        const collectionTemplate = document.getElementById('collection-template') as HTMLTemplateElement;
        if(collectionTemplate === null) {
            throw new Error("No template element with id 'collection-template' was found");
        }

        const collectionsContainer = document.getElementById('collection-container');
        if(collectionsContainer === null) {
            throw new Error("No element with id 'collection-container' was found");
        }

        // Create some new collectionSection elements, one for each collection
        // Store them in an array
        const placeholderCollectionSections: Array<HTMLElement> = [];
        const collectionSections: Array<HTMLElement> = [];

        // Create templates for placeholder and loaded collections
        for(let i = 0; i < collectionsPromises.length; i++) {
            // Clone the placeholder template that is used while collection is being loaded
            let placeholderTemplateFragment = collectionPlaceholderTemplate.content.cloneNode(true) as DocumentFragment;
            let placeholderTemplateRoot = placeholderTemplateFragment.firstElementChild;
            
            // Clone the template that is used when collection is loaded
            let templateFragment = collectionTemplate.content.cloneNode(true) as DocumentFragment;
            let templateRoot: HTMLElement = templateFragment.firstElementChild as HTMLElement;
            if(templateRoot !== null) {
                // Hide the collection template until it is done loading
                templateRoot.style.display = 'none';
                collectionSections.push(templateRoot as HTMLElement);
                collectionsContainer.appendChild(templateRoot);
            }

            // Add the placeholder template to the page immediately, we will add the templated for the loaded collection later
            if(placeholderTemplateRoot !== null) {
                placeholderCollectionSections.push(placeholderTemplateRoot as HTMLElement);
                collectionsContainer.appendChild(placeholderTemplateFragment);
            }

            // Go through each loaded fetched collection and populate the collectionSection element with the collection data
            // When the image is loaded, remove the placeholder collection and show the loaded collection
            const collectionsPromise = collectionsPromises[i];
            collectionsPromise.then((collection) => {
                
                const newCollectionSection = collectionSections[i];
                const placeholderCollectionSection = placeholderCollectionSections[i];

                // Populate the collectionSection element with the collection data

                // Get the title element, which is the first element with the class "collection-title"
                const titleElem = newCollectionSection.getElementsByClassName('collection-title')[0];
                if(titleElem !== null) {
                    titleElem.innerHTML = collection.title;
                }
                else {
                    throw new Error("No element with class 'collection-title' was found in the collection template");
                }

                // Get the description element, which is the first element with the class "collection-description"
                const descriptionElem = newCollectionSection.getElementsByClassName('collection-description')[0];
                if(descriptionElem !== null) {
                    descriptionElem.innerHTML = collection.description;
                } else {
                    throw new Error("No element with class 'collection-description' was found in the collection template");
                }

                const imageElem = newCollectionSection.getElementsByClassName('collection-image')[0] as HTMLImageElement;

                if(imageElem === null) {
                    throw new Error("No element with class 'collection-image' was found in the collection template");
                }

                // Load the collection image into the image element
                if(collection.imageUrl === null) {
                    throw new Error(`Collection with handle ${collection.handle} has no imageUrl`);
                }

                const imageUrl = collection.imageUrl;

                loadImageIntoElement(imageUrl, imageElem).then((_imageElem) => {
                    const collectionPair = new CollectionPair(placeholderCollectionSection, newCollectionSection);
                    // Remove the placeholder collection from the pair from the collectionsContainer
                    collectionsContainer.removeChild(collectionPair.placeholder);
                    // Show the loaded collection
                    collectionPair.collection.style.display = 'block';
                });

                // Get the link element, which is the first element with the class "collection-link"
                const linkElem = newCollectionSection.getElementsByClassName('collection-link')[0];

                if(linkElem === null) {
                    throw new Error("No element with class 'collection-link' was found in the collection template");
                }

                const imageLinkElem = newCollectionSection.getElementsByClassName('collection-image-link')[0];

                if(imageLinkElem === null) {
                    throw new Error("No element with class 'collection-image-link' was found in the collection template");
                }

                const link = new URL(`products?collection=${collection.handle}`, document.location.href).href;
                if(linkElem !== null) {
                    linkElem.setAttribute('href', link);
                }
                if(imageLinkElem !== null) {
                    imageLinkElem.setAttribute('href', link);
                }

            });
        }

    }
}